import styled from "styled-components";

const BreadcrumbStyles = styled.section`
  border-bottom: 1px solid rgba(18, 23, 36, 0.2);
  padding: ${props => props.noPadding ? '0px 16px !important' : 'initial'};

  ${props => props.theme.media.lg} {
    padding: ${props => props.noPadding ? '0px 15% !important' : 'initial'};
  }

  .desktop {
    display: none;
    ${props => props.theme.media.lg} {
      display: block;
    }
  }

  .mobile {
    ${props => props.theme.media.lg} {
      display: none;
    }
  }

  ul.breadcrumbs  {
    list-style: none;
    margin: 8px 0;
    padding: 0px;
  }

  ul.breadcrumbs li {
    display: inline;
    font-family: Poppins;
    font-size: 16px;
  }

  ul.breadcrumbs li+li:before {
    padding: 8px;
    color: #121724;
    opacity: 0.4;
    content: '/';
  }

  ul.breadcrumbs li a {
    color: #1776B6;
    text-decoration: none;
  }

  .back-btn {
    position: relative;
    bottom: 2px;
  }

  .title-container {
    font-size: 18px;
    font-weight: 500;
    margin: auto;
    margin-left: 0px;
  }

  .route-title {
    display: inline;
    margin-left: 15px;
    color: rgba(18, 23, 36, 0.91);
  }

  .breadcrumbs.mobile {
    display: flex;
    height: 56px;
    margin: auto;
    ${props => props.theme.media.lg} {
      display: none;
    }
  }

  .search {
    margin: auto;
    margin-right: 0px;
  }

`;

export default BreadcrumbStyles;